/* Auto-advance collection pages if current page renders zero visible cards after client-side filtering
   Optimized: checks up to 3 pages ahead in parallel, then HARD-NAVIGATES to the first non-empty page
   to keep Zest pagination state correct (prevents duplicates).
*/
(function () {
  if (window.__autoAdvanceInstalledV2) return;
  window.__autoAdvanceInstalledV2 = true;

  function fetchSectionHTML(page, sectionId) {
    var url = new URL(window.location.href);
    url.searchParams.set('page', String(page));
    url.searchParams.set('section_id', sectionId);
    return fetch(url.toString(), { credentials: 'same-origin' }).then(function (res) { return res.text(); });
  }

  function parseGridFromHTML(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.querySelector('#ProductGridContainer');
  }

  function pageHasVisibleCards(gridEl) {
    if (!gridEl) return false;
    var cards = gridEl.querySelectorAll('[data-product-card]');
    return cards.length > 0;
  }

  function tryAutoAdvanceIfEmpty() {
    var grid = document.getElementById('ProductGridContainer');
    if (!grid) return;

    var sectionId = grid.getAttribute('data-section-id') || 'main-collection-product-grid';
    var currentPage = parseInt(grid.getAttribute('data-current-page') || '1', 10);
    var totalPages = parseInt(grid.getAttribute('data-total-pages') || '1', 10);

    // If we already have visible cards, nothing to do.
    if (pageHasVisibleCards(grid)) return;

    // If there's nowhere to advance, stop.
    if (!(currentPage < totalPages)) return;

    // Check up to 3 pages ahead in parallel for speed.
    var maxLookahead = Math.min(3, totalPages - currentPage);
    var pagesToCheck = [];
    for (var i = 1; i <= maxLookahead; i++) pagesToCheck.push(currentPage + i);

    var checks = pagesToCheck.map(function (p) {
      return fetchSectionHTML(p, sectionId)
        .then(function (html) {
          var nextGrid = parseGridFromHTML(html);
          return { page: p, hasCards: pageHasVisibleCards(nextGrid) };
        })
        .catch(function () { return { page: p, hasCards: false }; });
    });

    Promise.all(checks).then(function (results) {
      // Find the earliest page that has visible cards.
      results.sort(function (a, b) { return a.page - b.page; });
      var hit = results.find(function (r) { return r.hasCards; });

      if (!hit) {
        // If none of the next 3 pages have results but more pages exist, fall back to sequential scan beyond lookahead.
        var nextStart = currentPage + maxLookahead + 1;
        sequentialScan(nextStart);
        return;
      }

      // Hard-navigate to keep theme pagination state correct (prevents duplicate products across pages)
      var url = new URL(window.location.href);
      url.searchParams.set('page', String(hit.page));
      window.location.replace(url.toString());
    });

    function sequentialScan(startPage) {
      var p = startPage;
      var safety = 10; // don't loop forever
      function step() {
        if (p > totalPages || safety-- <= 0) return;
        fetchSectionHTML(p, sectionId).then(function (html) {
          var nextGrid = parseGridFromHTML(html);
          if (pageHasVisibleCards(nextGrid)) {
            var url = new URL(window.location.href);
            url.searchParams.set('page', String(p));
            window.location.replace(url.toString());
          } else {
            p += 1;
            step();
          }
        }).catch(function () { /* skip on error */ p += 1; step(); });
      }
      step();
    }
  }

  // Fire on load and after AJAX facet renders
  document.addEventListener('DOMContentLoaded', tryAutoAdvanceIfEmpty);
  document.addEventListener('shopify:section:load', tryAutoAdvanceIfEmpty);
  document.addEventListener('facets:rendered', tryAutoAdvanceIfEmpty);
  document.addEventListener('collection:updated', tryAutoAdvanceIfEmpty);
})();
